import { mapState } from "vuex";

export default {
  mounted() {
    if (!this.socketEvents || !this.socket.connected) return;
    for (let event in this.socketEvents)
      this.socket.on(event, this.socketEvents[event]);
  },
  computed: {
    ...mapState(["socket"]),
    socketEvents() {
      if (!this.$options.events) return null;
      if (this.$options.events instanceof Function)
        return this.$options.events.bind(this)();
      return this.$options.events;
    },
  },
  beforeDestroy() {
    if (!this.socketEvents || !this.socket.connected) return;
    for (let event in this.socketEvents)
      this.socket.removeListener(event, this.socketEvents[event]);
  },
  watch: {
    /*
      The problem is that the App.vue is mounted while the socket is not connected yet,
      and this watcher doesn't have 'deep' option that watches the properties within the socket object
      so it could never work for the App.vue events

      Check store/index.ts line 199
    */
    socket: {
      handler: function (val) {
        if (!!val.connected && !!this.socketEvents) {
          for (let event in this.socketEvents) {
            val.on(event, this.socketEvents[event]);
          }
        }
      },
    },
  },
};
